import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/shared";
import { Skeleton } from "@/components/ui/skeleton";
import { ShieldCheck, AlertCircle, CheckCircle2 } from "lucide-react";

export default function Security() {
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/security/overview").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <Skeleton className="h-72 w-full" />;
  const color = d.average_score >= 80 ? "text-emerald-500" : d.average_score >= 50 ? "text-amber-500" : "text-rose-500";
  return (
    <div className="space-y-5">
      <PageHeader title="Security" desc="Per-bot security posture, token hygiene and recommendations." testId="security-header" />
      <div className="grid lg:grid-cols-4 gap-5">
        <div className="bg-card border border-border rounded-lg p-6 flex flex-col items-center justify-center">
          <ShieldCheck size={22} className="text-primary mb-2" />
          <div className="text-xs uppercase text-muted-foreground">Avg score</div>
          <div className={`text-5xl font-bold mono ${color}`}>{d.average_score}</div>
        </div>
        <div className="lg:col-span-3 bg-card border border-border rounded-lg overflow-hidden">
          {d.bots.length === 0 ? <EmptyState icon={ShieldCheck} title="No provisioned bots" desc="Security checks run on bots with a token." testId="empty-security" /> : (
            <div className="divide-y divide-border">
              {d.bots.map((b) => (
                <button key={b.bot_id} onClick={() => navigate(`/bots/${b.bot_id}`)} data-testid={`security-bot-${b.bot_id}`} className="w-full flex items-center justify-between p-4 hover:bg-secondary/40 text-left">
                  <div className="flex items-center gap-3">
                    {b.warnings.length === 0 ? <CheckCircle2 size={18} className="text-emerald-500" /> : <AlertCircle size={18} className="text-amber-500" />}
                    <div><div className="font-medium text-sm mono">@{b.name}</div><div className="text-xs text-muted-foreground">{b.warnings.length ? `${b.warnings.length} recommendation(s)` : "All checks passing"}</div></div>
                  </div>
                  <span className={`text-lg font-bold mono ${b.score >= 80 ? "text-emerald-500" : b.score >= 50 ? "text-amber-500" : "text-rose-500"}`}>{b.score}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
